import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "../utils/storeApp";

const useGcpUnavailableRedirect = (condition, deps = []) => {
  const navigate = useNavigate();
  const setGcpFeatureUnavailable = useUserStore(
    (state) => state.setGcpFeatureUnavailable,
  );

  useEffect(() => {
    if (condition) {
      setGcpFeatureUnavailable(true);
      navigate("/dashboard", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [condition, ...deps]);
};

export default useGcpUnavailableRedirect;
